import { useState, useEffect } from 'react';

export const objRemoveEmptyAndFalseyProperties = (obj) => {
    for (const key of Object.keys(obj)) {
        if (typeof obj[key] === 'object' && obj[key] !== null) { // (typeof null === 'object')
            objRemoveEmptyAndFalseyProperties(obj[key]);

            if (Object.values(obj[key]).length === 0) {
                delete obj[key];
            }

            continue;
        }

        if (obj[key] !== 0 && !obj[key]) {
            delete obj[key];
        }
    }
};

export const findLowestPrice = prices => {
    let lowestPrice = null;
    for (const {amount: price} of prices) {
        if (lowestPrice === null || price < lowestPrice) {
            lowestPrice = price;
        }
    }

    if (lowestPrice === null) {
        // No lowest price available (Happens if we don't have prices or all price categories are free)
        return null;
    }

    return 'ab ' + lowestPrice.toFixed(2) + '€';
};

export const extractDate = (rawDate, reverse = false) => {
    const dateObj = new Date(rawDate);
    const year = dateObj.getFullYear();
    const month = ('0' + (dateObj.getMonth() + 1)).slice(-2);
    const day = ('0' + dateObj.getDate()).slice(-2);

    return (
        reverse ? year + '.' + month + '.' + day : day + '.' + month + '.' + year
    );
};

export const extractTime = (rawDate) => {
    const dateObj = new Date(rawDate);
    const hour = dateObj.getHours();
    const minute = dateObj.getMinutes();

    const updatedHour = hour < 10 ? '0' + hour : hour;
    const updatedMinute = minute < 10 ? '0' + minute : minute;

    return updatedHour + ':' + updatedMinute;
};

export const eventDate = (startDate, endDate) => {
    const start = extractDate(startDate);
    const end = extractDate(endDate);

    if (start === end) {
        return start;
    } else {
        return start + ' - ' + end;
    }
};

export const eventTime = (startDate, endDate) => {
    const start = extractTime(startDate);
    const end = extractTime(endDate);

    if (start === end) {
        return start;
    } else {
        return start + ' - ' + end;
    }
};

export const eventDuration = (startDate, endDate) => {
    const start = extractTime(startDate);
    const end = extractTime(endDate);

    return start + ' - ' + end + ' Uhr';
};

export const isJsonParsable = string => {
    try {
        JSON.parse(string);
    } catch (e) {
        return false;
    }
    return true;
};

export function useWindowWidth() {
    const [size, setSize] = useState([window.innerWidth, window.innerHeight]);

    // Register resize listener
    useEffect(() => {
        const updateSize = () => setSize([window.innerWidth, window.innerHeight]);

        window.addEventListener('resize', updateSize);

        return () => window.removeEventListener('resize', updateSize);
    }, []);

    return size;
}

export function camelCaseToKebabCase(string) {
    return string.replace(/([a-z0-9]|(?=[A-Z]))([A-Z])/g, '$1-$2').toLowerCase();
}

export function isAbsoluteUrl(url) {
    return url.startsWith('https://') || url.startsWith('http://');
}

export const findCategory = (categories, categoryId) => categories.find(category => category.id === categoryId);
